
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire49a6"];
var parcelRegister = parcelRequire.register;
parcelRegister("6olJd", function(module, exports) {

$parcel$export(module.exports, "OpenTransition", function () { return $4a75d6c740e7ec84$export$b847a40ee92eff38; });
$parcel$export(module.exports, "Overlay", function () { return $4a75d6c740e7ec84$export$c6fdb837b070b4ff; });
$parcel$export(module.exports, "Popover", function () { return $4a75d6c740e7ec84$export$5b6b19405a83ff9d; });
$parcel$export(module.exports, "Modal", function () { return $4a75d6c740e7ec84$export$2b77a92f1a5ad772; });
$parcel$export(module.exports, "Tray", function () { return $4a75d6c740e7ec84$export$4589ed81930b555c; });


var $jxYT9 = parcelRequire("jxYT9");

var $7eprg = parcelRequire("7eprg");

var $20dvM = parcelRequire("20dvM");

var $aQDJL = parcelRequire("aQDJL");

var $cYn9G = parcelRequire("cYn9G");

var $aCJeV = parcelRequire("aCJeV");

var $5mLCk = parcelRequire("5mLCk");
function $4a75d6c740e7ec84$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
function $4a75d6c740e7ec84$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /// <reference types="css-module-types" />
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $4a75d6c740e7ec84$var$$bc765a7a041310da$var$OPEN_STATES = {
    entering: false,
    entered: true
};
function $4a75d6c740e7ec84$export$b847a40ee92eff38(props) {
    var child;
    return (0, (/*@__PURE__*/$parcel$interopDefault($7eprg))).createElement((0, $aQDJL.default), {
        timeout: {
            enter: 0,
            exit: 350
        },
        ...props
    }, (state)=>(0, (/*@__PURE__*/$parcel$interopDefault($7eprg))).Children.map(props.children, (child)=>child && (0, (/*@__PURE__*/$parcel$interopDefault($7eprg))).cloneElement(child, {
                isOpen: !!$4a75d6c740e7ec84$var$$bc765a7a041310da$var$OPEN_STATES[state]
            })));
}
function $4a75d6c740e7ec84$var$$70305dc5fb729c3b$var$Overlay(props, ref) {
    let { children: children, isOpen: isOpen, disableFocusManagement: disableFocusManagement, container: container, onEnter: onEnter, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onExited: onExited, nodeRef: nodeRef } = props;
    let [exited, setExited] = (0, $7eprg.useState)(!isOpen);
    let handleEntered = (0, $7eprg.useCallback)(()=>{
        setExited(false);
        if (onEntered) onEntered();
    }, [
        onEntered
    ]);
    let handleExited = (0, $7eprg.useCallback)(()=>{
        setExited(true);
        if (onExited) onExited();
    }, [
        onExited
    ]);
    // Don't un-render the overlay while it's transitioning out.
    let mountOverlay = isOpen || !exited;
    if (!mountOverlay) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($7eprg))).createElement((0, $20dvM.Overlay), {
        portalContainer: container,
        disableFocusManagement: disableFocusManagement,
        isExiting: !isOpen
    }, (0, (/*@__PURE__*/$parcel$interopDefault($7eprg))).createElement((0, $jxYT9.Provider), {
        ref: ref,
        UNSAFE_style: {
            background: "transparent",
            isolation: "isolate"
        },
        isDisabled: false
    }, (0, (/*@__PURE__*/$parcel$interopDefault($7eprg))).createElement($4a75d6c740e7ec84$export$b847a40ee92eff38, {
        in: isOpen,
        appear: true,
        onExit: onExit,
        onExiting: onExiting,
        onExited: handleExited,
        onEnter: onEnter,
        onEntering: onEntering,
        onEntered: handleEntered,
        nodeRef: nodeRef
    }, children)));
}
let $4a75d6c740e7ec84$export$c6fdb837b070b4ff = (0, (/*@__PURE__*/$parcel$interopDefault($7eprg))).forwardRef($4a75d6c740e7ec84$var$$70305dc5fb729c3b$var$Overlay);
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var $4a75d6c740e7ec84$var$$853e19557ad8790f$exports = {};
$4a75d6c740e7ec84$var$$parcel$export($4a75d6c740e7ec84$var$$853e19557ad8790f$exports, "react-spectrum-Modal", ()=>$4a75d6c740e7ec84$var$$853e19557ad8790f$export$f8edeb62d7fed8c1, (v)=>$4a75d6c740e7ec84$var$$853e19557ad8790f$export$f8edeb62d7fed8c1 = v);
$4a75d6c740e7ec84$var$$parcel$export($4a75d6c740e7ec84$var$$853e19557ad8790f$exports, "react-spectrum-Modal-wrapper", ()=>$4a75d6c740e7ec84$var$$853e19557ad8790f$export$e088717c213c31d7, (v)=>$4a75d6c740e7ec84$var$$853e19557ad8790f$export$e088717c213c31d7 = v);
$4a75d6c740e7ec84$var$$parcel$export($4a75d6c740e7ec84$var$$853e19557ad8790f$exports, "react-spectrum-Popover", ()=>$4a75d6c740e7ec84$var$$853e19557ad8790f$export$884f6b5065bdc41a, (v)=>$4a75d6c740e7ec84$var$$853e19557ad8790f$export$884f6b5065bdc41a = v);
$4a75d6c740e7ec84$var$$parcel$export($4a75d6c740e7ec84$var$$853e19557ad8790f$exports, "react-spectrum-Tray", ()=>$4a75d6c740e7ec84$var$$853e19557ad8790f$export$69dafa24343974dd, (v)=>$4a75d6c740e7ec84$var$$853e19557ad8790f$export$69dafa24343974dd = v);
$4a75d6c740e7ec84$var$$parcel$export($4a75d6c740e7ec84$var$$853e19557ad8790f$exports, "spectrum-Dialog-content", ()=>$4a75d6c740e7ec84$var$$853e19557ad8790f$export$cb8eccd0f3639238, (v)=>$4a75d6c740e7ec84$var$$853e19557ad8790f$export$cb8eccd0f3639238 = v);
$4a75d6c740e7ec84$var$$parcel$export($4a75d6c740e7ec84$var$$853e19557ad8790f$exports, "spectrum-Modal", ()=>$4a75d6c740e7ec84$var$$853e19557ad8790f$export$4c0b1e44c3834c85, (v)=>$4a75d6c740e7ec84$var$$853e19557ad8790f$export$4c0b1e44c3834c85 = v);
$4a75d6c740e7ec84$var$$parcel$export($4a75d6c740e7ec84$var$$853e19557ad8790f$exports, "spectrum-Modal-wrapper", ()=>$4a75d6c740e7ec84$var$$853e19557ad8790f$export$35bea187ff802494, (v)=>$4a75d6c740e7ec84$var$$853e19557ad8790f$export$35bea187ff802494 = v);
$4a75d6c740e7ec84$var$$parcel$export($4a75d6c740e7ec84$var$$853e19557ad8790f$exports, "spectrum-Popover", ()=>$4a75d6c740e7ec84$var$$853e19557ad8790f$export$a62dc1b6ab23a7bb, (v)=>$4a75d6c740e7ec84$var$$853e19557ad8790f$export$a62dc1b6ab23a7bb = v);
$4a75d6c740e7ec84$var$$parcel$export($4a75d6c740e7ec84$var$$853e19557ad8790f$exports, "spectrum-Tray", ()=>$4a75d6c740e7ec84$var$$853e19557ad8790f$export$ce0704cd084c4f0d, (v)=>$4a75d6c740e7ec84$var$$853e19557ad8790f$export$ce0704cd084c4f0d = v);
var $4a75d6c740e7ec84$var$$853e19557ad8790f$export$f8edeb62d7fed8c1;
var $4a75d6c740e7ec84$var$$853e19557ad8790f$export$e088717c213c31d7;
var $4a75d6c740e7ec84$var$$853e19557ad8790f$export$884f6b5065bdc41a;
var $4a75d6c740e7ec84$var$$853e19557ad8790f$export$69dafa24343974dd;
var $4a75d6c740e7ec84$var$$853e19557ad8790f$export$cb8eccd0f3639238;
var $4a75d6c740e7ec84$var$$853e19557ad8790f$export$4c0b1e44c3834c85;
var $4a75d6c740e7ec84$var$$853e19557ad8790f$export$35bea187ff802494;
var $4a75d6c740e7ec84$var$$853e19557ad8790f$export$a62dc1b6ab23a7bb;
var $4a75d6c740e7ec84$var$$853e19557ad8790f$export$ce0704cd084c4f0d;
$4a75d6c740e7ec84$var$$853e19557ad8790f$export$f8edeb62d7fed8c1 = `OhnpTq_react-spectrum-Modal`;
$4a75d6c740e7ec84$var$$853e19557ad8790f$export$e088717c213c31d7 = `OhnpTq_react-spectrum-Modal-wrapper`;
$4a75d6c740e7ec84$var$$853e19557ad8790f$export$884f6b5065bdc41a = `OhnpTq_react-spectrum-Popover`;
$4a75d6c740e7ec84$var$$853e19557ad8790f$export$69dafa24343974dd = `OhnpTq_react-spectrum-Tray`;
$4a75d6c740e7ec84$var$$853e19557ad8790f$export$cb8eccd0f3639238 = `OhnpTq_spectrum-Dialog-content`;
$4a75d6c740e7ec84$var$$853e19557ad8790f$export$4c0b1e44c3834c85 = `OhnpTq_spectrum-Modal`;
$4a75d6c740e7ec84$var$$853e19557ad8790f$export$35bea187ff802494 = `OhnpTq_spectrum-Modal-wrapper`;
$4a75d6c740e7ec84$var$$853e19557ad8790f$export$a62dc1b6ab23a7bb = `OhnpTq_spectrum-Popover`;
$4a75d6c740e7ec84$var$$853e19557ad8790f$export$ce0704cd084c4f0d = `OhnpTq_spectrum-Tray`;
var $4a75d6c740e7ec84$var$$645594d913f34a2a$exports = {};
$4a75d6c740e7ec84$var$$parcel$export($4a75d6c740e7ec84$var$$645594d913f34a2a$exports, "focus-ring", ()=>$4a75d6c740e7ec84$var$$645594d913f34a2a$export$f39a09f249340e2a, (v)=>$4a75d6c740e7ec84$var$$645594d913f34a2a$export$f39a09f249340e2a = v);
$4a75d6c740e7ec84$var$$parcel$export($4a75d6c740e7ec84$var$$645594d913f34a2a$exports, "i18nFontFamily", ()=>$4a75d6c740e7ec84$var$$645594d913f34a2a$export$8c4ee2c50c22c514, (v)=>$4a75d6c740e7ec84$var$$645594d913f34a2a$export$8c4ee2c50c22c514 = v);
$4a75d6c740e7ec84$var$$parcel$export($4a75d6c740e7ec84$var$$645594d913f34a2a$exports, "spectrum-overlay--open", ()=>$4a75d6c740e7ec84$var$$645594d913f34a2a$export$a397eb58038aa381, (v)=>$4a75d6c740e7ec84$var$$645594d913f34a2a$export$a397eb58038aa381 = v);
$4a75d6c740e7ec84$var$$parcel$export($4a75d6c740e7ec84$var$$645594d913f34a2a$exports, "is-open", ()=>$4a75d6c740e7ec84$var$$645594d913f34a2a$export$a9781837241c946d, (v)=>$4a75d6c740e7ec84$var$$645594d913f34a2a$export$a9781837241c946d = v);
$4a75d6c740e7ec84$var$$parcel$export($4a75d6c740e7ec84$var$$645594d913f34a2a$exports, "spectrum-overlay--bottom--open", ()=>$4a75d6c740e7ec84$var$$645594d913f34a2a$export$a96755f239de61ee, (v)=>$4a75d6c740e7ec84$var$$645594d913f34a2a$export$a96755f239de61ee = v);
$4a75d6c740e7ec84$var$$parcel$export($4a75d6c740e7ec84$var$$645594d913f34a2a$exports, "is-open--bottom", ()=>$4a75d6c740e7ec84$var$$645594d913f34a2a$export$1f160596ffe52357, (v)=>$4a75d6c740e7ec84$var$$645594d913f34a2a$export$1f160596ffe52357 = v);
$4a75d6c740e7ec84$var$$parcel$export($4a75d6c740e7ec84$var$$645594d913f34a2a$exports, "spectrum-overlay--left--open", ()=>$4a75d6c740e7ec84$var$$645594d913f34a2a$export$a85c0c6b6cf8598c, (v)=>$4a75d6c740e7ec84$var$$645594d913f34a2a$export$a85c0c6b6cf8598c = v);
$4a75d6c740e7ec84$var$$parcel$export($4a75d6c740e7ec84$var$$645594d913f34a2a$exports, "is-open--left", ()=>$4a75d6c740e7ec84$var$$645594d913f34a2a$export$d6106cb3acaf56ae, (v)=>$4a75d6c740e7ec84$var$$645594d913f34a2a$export$d6106cb3acaf56ae = v);
$4a75d6c740e7ec84$var$$parcel$export($4a75d6c740e7ec84$var$$645594d913f34a2a$exports, "spectrum-overlay--right--open", ()=>$4a75d6c740e7ec84$var$$645594d913f34a2a$export$85aaa87e65e040bf, (v)=>$4a75d6c740e7ec84$var$$645594d913f34a2a$export$85aaa87e65e040bf = v);
$4a75d6c740e7ec84$var$$parcel$export($4a75d6c740e7ec84$var$$645594d913f34a2a$exports, "is-open--right", ()=>$4a75d6c740e7ec84$var$$645594d913f34a2a$export$8935d072812c3169, (v)=>$4a75d6c740e7ec84$var$$645594d913f34a2a$export$8935d072812c3169 = v);
$4a75d6c740e7ec84$var$$parcel$export($4a75d6c740e7ec84$var$$645594d913f34a2a$exports, "spectrum-overlay--top--open", ()=>$4a75d6c740e7ec84$var$$645594d913f34a2a$export$b9768db7ffc1bc2, (v)=>$4a75d6c740e7ec84$var$$645594d913f34a2a$export$b9768db7ffc1bc2 = v);
$4a75d6c740e7ec84$var$$parcel$export($4a75d6c740e7ec84$var$$645594d913f34a2a$exports, "is-open--top", ()=>$4a75d6c740e7ec84$var$$645594d913f34a2a$export$cd4bf1e07ae86214, (v)=>$4a75d6c740e7ec84$var$$645594d913f34a2a$export$cd4bf1e07ae86214 = v);
$4a75d6c740e7ec84$var$$parcel$export($4a75d6c740e7ec84$var$$645594d913f34a2a$exports, "spectrum-FocusRing-ring", ()=>$4a75d6c740e7ec84$var$$645594d913f34a2a$export$4109102f950813a6, (v)=>$4a75d6c740e7ec84$var$$645594d913f34a2a$export$4109102f950813a6 = v);
$4a75d6c740e7ec84$var$$parcel$export($4a75d6c740e7ec84$var$$645594d913f34a2a$exports, "spectrum-FocusRing", ()=>$4a75d6c740e7ec84$var$$645594d913f34a2a$export$24c7f46a6e3605dd, (v)=>$4a75d6c740e7ec84$var$$645594d913f34a2a$export$24c7f46a6e3605dd = v);
$4a75d6c740e7ec84$var$$parcel$export($4a75d6c740e7ec84$var$$645594d913f34a2a$exports, "spectrum-FocusRing--quiet", ()=>$4a75d6c740e7ec84$var$$645594d913f34a2a$export$2927016961429360, (v)=>$4a75d6c740e7ec84$var$$645594d913f34a2a$export$2927016961429360 = v);
$4a75d6c740e7ec84$var$$parcel$export($4a75d6c740e7ec84$var$$645594d913f34a2a$exports, "spectrum-overlay", ()=>$4a75d6c740e7ec84$var$$645594d913f34a2a$export$39eed38e2296a1d6, (v)=>$4a75d6c740e7ec84$var$$645594d913f34a2a$export$39eed38e2296a1d6 = v);
$4a75d6c740e7ec84$var$$parcel$export($4a75d6c740e7ec84$var$$645594d913f34a2a$exports, "spectrum-Popover", ()=>$4a75d6c740e7ec84$var$$645594d913f34a2a$export$a62dc1b6ab23a7bb, (v)=>$4a75d6c740e7ec84$var$$645594d913f34a2a$export$a62dc1b6ab23a7bb = v);
$4a75d6c740e7ec84$var$$parcel$export($4a75d6c740e7ec84$var$$645594d913f34a2a$exports, "spectrum-Popover--bottom", ()=>$4a75d6c740e7ec84$var$$645594d913f34a2a$export$6a19b19b14780d4a, (v)=>$4a75d6c740e7ec84$var$$645594d913f34a2a$export$6a19b19b14780d4a = v);
$4a75d6c740e7ec84$var$$parcel$export($4a75d6c740e7ec84$var$$645594d913f34a2a$exports, "spectrum-Popover--dialog", ()=>$4a75d6c740e7ec84$var$$645594d913f34a2a$export$cf634262e726cd19, (v)=>$4a75d6c740e7ec84$var$$645594d913f34a2a$export$cf634262e726cd19 = v);
$4a75d6c740e7ec84$var$$parcel$export($4a75d6c740e7ec84$var$$645594d913f34a2a$exports, "spectrum-Popover--left", ()=>$4a75d6c740e7ec84$var$$645594d913f34a2a$export$79cc55906ac5b00, (v)=>$4a75d6c740e7ec84$var$$645594d913f34a2a$export$79cc55906ac5b00 = v);
$4a75d6c740e7ec84$var$$parcel$export($4a75d6c740e7ec84$var$$645594d913f34a2a$exports, "spectrum-Popover--right", ()=>$4a75d6c740e7ec84$var$$645594d913f34a2a$export$5fc8b429396c9f58, (v)=>$4a75d6c740e7ec84$var$$645594d913f34a2a$export$5fc8b429396c9f58 = v);
$4a75d6c740e7ec84$var$$parcel$export($4a75d6c740e7ec84$var$$645594d913f34a2a$exports, "spectrum-Popover--top", ()=>$4a75d6c740e7ec84$var$$645594d913f34a2a$export$f30becfb1df0cae4, (v)=>$4a75d6c740e7ec84$var$$645594d913f34a2a$export$f30becfb1df0cae4 = v);
$4a75d6c740e7ec84$var$$parcel$export($4a75d6c740e7ec84$var$$645594d913f34a2a$exports, "spectrum-Popover--withTip", ()=>$4a75d6c740e7ec84$var$$645594d913f34a2a$export$d8b16c5377728262, (v)=>$4a75d6c740e7ec84$var$$645594d913f34a2a$export$d8b16c5377728262 = v);
$4a75d6c740e7ec84$var$$parcel$export($4a75d6c740e7ec84$var$$645594d913f34a2a$exports, "spectrum-Popover-tip", ()=>$4a75d6c740e7ec84$var$$645594d913f34a2a$export$3100ec4dc1668df1, (v)=>$4a75d6c740e7ec84$var$$645594d913f34a2a$export$3100ec4dc1668df1 = v);
$4a75d6c740e7ec84$var$$parcel$export($4a75d6c740e7ec84$var$$645594d913f34a2a$exports, "spectrum-Popover-tip-triangle", ()=>$4a75d6c740e7ec84$var$$645594d913f34a2a$export$ed733fa6cf19ab80, (v)=>$4a75d6c740e7ec84$var$$645594d913f34a2a$export$ed733fa6cf19ab80 = v);
var $4a75d6c740e7ec84$var$$645594d913f34a2a$export$f39a09f249340e2a;
var $4a75d6c740e7ec84$var$$645594d913f34a2a$export$8c4ee2c50c22c514;
var $4a75d6c740e7ec84$var$$645594d913f34a2a$export$a397eb58038aa381;
var $4a75d6c740e7ec84$var$$645594d913f34a2a$export$a9781837241c946d;
var $4a75d6c740e7ec84$var$$645594d913f34a2a$export$a96755f239de61ee;
var $4a75d6c740e7ec84$var$$645594d913f34a2a$export$1f160596ffe52357;
var $4a75d6c740e7ec84$var$$645594d913f34a2a$export$a85c0c6b6cf8598c;
var $4a75d6c740e7ec84$var$$645594d913f34a2a$export$d6106cb3acaf56ae;
var $4a75d6c740e7ec84$var$$645594d913f34a2a$export$85aaa87e65e040bf;
var $4a75d6c740e7ec84$var$$645594d913f34a2a$export$8935d072812c3169;
var $4a75d6c740e7ec84$var$$645594d913f34a2a$export$b9768db7ffc1bc2;
var $4a75d6c740e7ec84$var$$645594d913f34a2a$export$cd4bf1e07ae86214;
var $4a75d6c740e7ec84$var$$645594d913f34a2a$export$4109102f950813a6;
var $4a75d6c740e7ec84$var$$645594d913f34a2a$export$24c7f46a6e3605dd;
var $4a75d6c740e7ec84$var$$645594d913f34a2a$export$2927016961429360;
var $4a75d6c740e7ec84$var$$645594d913f34a2a$export$39eed38e2296a1d6;
var $4a75d6c740e7ec84$var$$645594d913f34a2a$export$a62dc1b6ab23a7bb;
var $4a75d6c740e7ec84$var$$645594d913f34a2a$export$6a19b19b14780d4a;
var $4a75d6c740e7ec84$var$$645594d913f34a2a$export$cf634262e726cd19;
var $4a75d6c740e7ec84$var$$645594d913f34a2a$export$79cc55906ac5b00;
var $4a75d6c740e7ec84$var$$645594d913f34a2a$export$5fc8b429396c9f58;
var $4a75d6c740e7ec84$var$$645594d913f34a2a$export$f30becfb1df0cae4;
var $4a75d6c740e7ec84$var$$645594d913f34a2a$export$d8b16c5377728262;
var $4a75d6c740e7ec84$var$$645594d913f34a2a$export$3100ec4dc1668df1;
var $4a75d6c740e7ec84$var$$645594d913f34a2a$export$ed733fa6cf19ab80;
$4a75d6c740e7ec84$var$$645594d913f34a2a$export$f39a09f249340e2a = `cH0MeW_focus-ring`;
$4a75d6c740e7ec84$var$$645594d913f34a2a$export$8c4ee2c50c22c514 = `cH0MeW_i18nFontFamily`;
$4a75d6c740e7ec84$var$$645594d913f34a2a$export$a397eb58038aa381 = `cH0MeW_spectrum-overlay--open`;
$4a75d6c740e7ec84$var$$645594d913f34a2a$export$a9781837241c946d = `cH0MeW_is-open ${$4a75d6c740e7ec84$var$$645594d913f34a2a$export$a397eb58038aa381}`;
$4a75d6c740e7ec84$var$$645594d913f34a2a$export$a96755f239de61ee = `cH0MeW_spectrum-overlay--bottom--open`;
$4a75d6c740e7ec84$var$$645594d913f34a2a$export$1f160596ffe52357 = `cH0MeW_is-open--bottom ${$4a75d6c740e7ec84$var$$645594d913f34a2a$export$a96755f239de61ee}`;
$4a75d6c740e7ec84$var$$645594d913f34a2a$export$a85c0c6b6cf8598c = `cH0MeW_spectrum-overlay--left--open`;
$4a75d6c740e7ec84$var$$645594d913f34a2a$export$d6106cb3acaf56ae = `cH0MeW_is-open--left ${$4a75d6c740e7ec84$var$$645594d913f34a2a$export$a85c0c6b6cf8598c}`;
$4a75d6c740e7ec84$var$$645594d913f34a2a$export$85aaa87e65e040bf = `cH0MeW_spectrum-overlay--right--open`;
$4a75d6c740e7ec84$var$$645594d913f34a2a$export$8935d072812c3169 = `cH0MeW_is-open--right ${$4a75d6c740e7ec84$var$$645594d913f34a2a$export$85aaa87e65e040bf}`;
$4a75d6c740e7ec84$var$$645594d913f34a2a$export$b9768db7ffc1bc2 = `cH0MeW_spectrum-overlay--top--open`;
$4a75d6c740e7ec84$var$$645594d913f34a2a$export$cd4bf1e07ae86214 = `cH0MeW_is-open--top ${$4a75d6c740e7ec84$var$$645594d913f34a2a$export$b9768db7ffc1bc2}`;
$4a75d6c740e7ec84$var$$645594d913f34a2a$export$4109102f950813a6 = `cH0MeW_spectrum-FocusRing-ring`;
$4a75d6c740e7ec84$var$$645594d913f34a2a$export$24c7f46a6e3605dd = `cH0MeW_spectrum-FocusRing ${$4a75d6c740e7ec84$var$$645594d913f34a2a$export$4109102f950813a6}`;
$4a75d6c740e7ec84$var$$645594d913f34a2a$export$2927016961429360 = `cH0MeW_spectrum-FocusRing--quiet`;
$4a75d6c740e7ec84$var$$645594d913f34a2a$export$39eed38e2296a1d6 = `cH0MeW_spectrum-overlay`;
$4a75d6c740e7ec84$var$$645594d913f34a2a$export$a62dc1b6ab23a7bb = `cH0MeW_spectrum-Popover ${$4a75d6c740e7ec84$var$$645594d913f34a2a$export$39eed38e2296a1d6}`;
$4a75d6c740e7ec84$var$$645594d913f34a2a$export$6a19b19b14780d4a = `cH0MeW_spectrum-Popover--bottom`;
$4a75d6c740e7ec84$var$$645594d913f34a2a$export$cf634262e726cd19 = `cH0MeW_spectrum-Popover--dialog`;
$4a75d6c740e7ec84$var$$645594d913f34a2a$export$79cc55906ac5b00 = `cH0MeW_spectrum-Popover--left`;
$4a75d6c740e7ec84$var$$645594d913f34a2a$export$5fc8b429396c9f58 = `cH0MeW_spectrum-Popover--right`;
$4a75d6c740e7ec84$var$$645594d913f34a2a$export$f30becfb1df0cae4 = `cH0MeW_spectrum-Popover--top`;
$4a75d6c740e7ec84$var$$645594d913f34a2a$export$d8b16c5377728262 = `cH0MeW_spectrum-Popover--withTip`;
$4a75d6c740e7ec84$var$$645594d913f34a2a$export$3100ec4dc1668df1 = `cH0MeW_spectrum-Popover-tip`;
$4a75d6c740e7ec84$var$$645594d913f34a2a$export$ed733fa6cf19ab80 = `cH0MeW_spectrum-Popover-tip-triangle`;
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var $4a75d6c740e7ec84$var$$c77d7b73b2bbd0fb$exports = {};
$4a75d6c740e7ec84$var$$parcel$export($4a75d6c740e7ec84$var$$c77d7b73b2bbd0fb$exports, "focus-ring", ()=>$4a75d6c740e7ec84$var$$c77d7b73b2bbd0fb$export$f39a09f249340e2a, (v)=>$4a75d6c740e7ec84$var$$c77d7b73b2bbd0fb$export$f39a09f249340e2a = v);
$4a75d6c740e7ec84$var$$parcel$export($4a75d6c740e7ec84$var$$c77d7b73b2bbd0fb$exports, "i18nFontFamily", ()=>$4a75d6c740e7ec84$var$$c77d7b73b2bbd0fb$export$8c4ee2c50c22c514, (v)=>$4a75d6c740e7ec84$var$$c77d7b73b2bbd0fb$export$8c4ee2c50c22c514 = v);
$4a75d6c740e7ec84$var$$parcel$export($4a75d6c740e7ec84$var$$c77d7b73b2bbd0fb$exports, "spectrum-overlay--open", ()=>$4a75d6c740e7ec84$var$$c77d7b73b2bbd0fb$export$a397eb58038aa381, (v)=>$4a75d6c740e7ec84$var$$c77d7b73b2bbd0fb$export$a397eb58038aa381 = v);
$4a75d6c740e7ec84$var$$parcel$export($4a75d6c740e7ec84$var$$c77d7b73b2bbd0fb$exports, "is-open", ()=>$4a75d6c740e7ec84$var$$c77d7b73b2bbd0fb$export$a9781837241c946d, (v)=>$4a75d6c740e7ec84$var$$c77d7b73b2bbd0fb$export$a9781837241c946d = v);
$4a75d6c740e7ec84$var$$parcel$export($4a75d6c740e7ec84$var$$c77d7b73b2bbd0fb$exports, "spectrum-FocusRing-ring", ()=>$4a75d6c740e7ec84$var$$c77d7b73b2bbd0fb$export$4109102f950813a6, (v)=>$4a75d6c740e7ec84$var$$c77d7b73b2bbd0fb$export$4109102f950813a6 = v);
$4a75d6c740e7ec84$var$$parcel$export($4a75d6c740e7ec84$var$$c77d7b73b2bbd0fb$exports, "spectrum-FocusRing", ()=>$4a75d6c740e7ec84$var$$c77d7b73b2bbd0fb$export$24c7f46a6e3605dd, (v)=>$4a75d6c740e7ec84$var$$c77d7b73b2bbd0fb$export$24c7f46a6e3605dd = v);
$4a75d6c740e7ec84$var$$parcel$export($4a75d6c740e7ec84$var$$c77d7b73b2bbd0fb$exports, "spectrum-FocusRing--quiet", ()=>$4a75d6c740e7ec84$var$$c77d7b73b2bbd0fb$export$2927016961429360, (v)=>$4a75d6c740e7ec84$var$$c77d7b73b2bbd0fb$export$2927016961429360 = v);
$4a75d6c740e7ec84$var$$parcel$export($4a75d6c740e7ec84$var$$c77d7b73b2bbd0fb$exports, "spectrum-overlay", ()=>$4a75d6c740e7ec84$var$$c77d7b73b2bbd0fb$export$39eed38e2296a1d6, (v)=>$4a75d6c740e7ec84$var$$c77d7b73b2bbd0fb$export$39eed38e2296a1d6 = v);
$4a75d6c740e7ec84$var$$parcel$export($4a75d6c740e7ec84$var$$c77d7b73b2bbd0fb$exports, "spectrum-Underlay", ()=>$4a75d6c740e7ec84$var$$c77d7b73b2bbd0fb$export$74470528f463af97, (v)=>$4a75d6c740e7ec84$var$$c77d7b73b2bbd0fb$export$74470528f463af97 = v);
$4a75d6c740e7ec84$var$$parcel$export($4a75d6c740e7ec84$var$$c77d7b73b2bbd0fb$exports, "spectrum-Underlay--transparent", ()=>$4a75d6c740e7ec84$var$$c77d7b73b2bbd0fb$export$8eb3860104039b44, (v)=>$4a75d6c740e7ec84$var$$c77d7b73b2bbd0fb$export$8eb3860104039b44 = v);
$4a75d6c740e7ec84$var$$parcel$export($4a75d6c740e7ec84$var$$c77d7b73b2bbd0fb$exports, "spectrum-overlay--bottom--open", ()=>$4a75d6c740e7ec84$var$$c77d7b73b2bbd0fb$export$a96755f239de61ee, (v)=>$4a75d6c740e7ec84$var$$c77d7b73b2bbd0fb$export$a96755f239de61ee = v);
$4a75d6c740e7ec84$var$$parcel$export($4a75d6c740e7ec84$var$$c77d7b73b2bbd0fb$exports, "spectrum-overlay--left--open", ()=>$4a75d6c740e7ec84$var$$c77d7b73b2bbd0fb$export$a85c0c6b6cf8598c, (v)=>$4a75d6c740e7ec84$var$$c77d7b73b2bbd0fb$export$a85c0c6b6cf8598c = v);
$4a75d6c740e7ec84$var$$parcel$export($4a75d6c740e7ec84$var$$c77d7b73b2bbd0fb$exports, "spectrum-overlay--right--open", ()=>$4a75d6c740e7ec84$var$$c77d7b73b2bbd0fb$export$85aaa87e65e040bf, (v)=>$4a75d6c740e7ec84$var$$c77d7b73b2bbd0fb$export$85aaa87e65e040bf = v);
$4a75d6c740e7ec84$var$$parcel$export($4a75d6c740e7ec84$var$$c77d7b73b2bbd0fb$exports, "spectrum-overlay--top--open", ()=>$4a75d6c740e7ec84$var$$c77d7b73b2bbd0fb$export$b9768db7ffc1bc2, (v)=>$4a75d6c740e7ec84$var$$c77d7b73b2bbd0fb$export$b9768db7ffc1bc2 = v);
var $4a75d6c740e7ec84$var$$c77d7b73b2bbd0fb$export$f39a09f249340e2a;
var $4a75d6c740e7ec84$var$$c77d7b73b2bbd0fb$export$8c4ee2c50c22c514;
var $4a75d6c740e7ec84$var$$c77d7b73b2bbd0fb$export$a397eb58038aa381;
var $4a75d6c740e7ec84$var$$c77d7b73b2bbd0fb$export$a9781837241c946d;
var $4a75d6c740e7ec84$var$$c77d7b73b2bbd0fb$export$4109102f950813a6;
var $4a75d6c740e7ec84$var$$c77d7b73b2bbd0fb$export$24c7f46a6e3605dd;
var $4a75d6c740e7ec84$var$$c77d7b73b2bbd0fb$export$2927016961429360;
var $4a75d6c740e7ec84$var$$c77d7b73b2bbd0fb$export$39eed38e2296a1d6;
var $4a75d6c740e7ec84$var$$c77d7b73b2bbd0fb$export$74470528f463af97;
var $4a75d6c740e7ec84$var$$c77d7b73b2bbd0fb$export$8eb3860104039b44;
var $4a75d6c740e7ec84$var$$c77d7b73b2bbd0fb$export$a96755f239de61ee;
var $4a75d6c740e7ec84$var$$c77d7b73b2bbd0fb$export$a85c0c6b6cf8598c;
var $4a75d6c740e7ec84$var$$c77d7b73b2bbd0fb$export$85aaa87e65e040bf;
var $4a75d6c740e7ec84$var$$c77d7b73b2bbd0fb$export$b9768db7ffc1bc2;
$4a75d6c740e7ec84$var$$c77d7b73b2bbd0fb$export$f39a09f249340e2a = `F-oYUa_focus-ring`;
$4a75d6c740e7ec84$var$$c77d7b73b2bbd0fb$export$8c4ee2c50c22c514 = `F-oYUa_i18nFontFamily`;
$4a75d6c740e7ec84$var$$c77d7b73b2bbd0fb$export$a397eb58038aa381 = `F-oYUa_spectrum-overlay--open`;
$4a75d6c740e7ec84$var$$c77d7b73b2bbd0fb$export$a9781837241c946d = `F-oYUa_is-open ${$4a75d6c740e7ec84$var$$c77d7b73b2bbd0fb$export$a397eb58038aa381}`;
$4a75d6c740e7ec84$var$$c77d7b73b2bbd0fb$export$4109102f950813a6 = `F-oYUa_spectrum-FocusRing-ring`;
$4a75d6c740e7ec84$var$$c77d7b73b2bbd0fb$export$24c7f46a6e3605dd = `F-oYUa_spectrum-FocusRing ${$4a75d6c740e7ec84$var$$c77d7b73b2bbd0fb$export$4109102f950813a6}`;
$4a75d6c740e7ec84$var$$c77d7b73b2bbd0fb$export$2927016961429360 = `F-oYUa_spectrum-FocusRing--quiet`;
$4a75d6c740e7ec84$var$$c77d7b73b2bbd0fb$export$39eed38e2296a1d6 = `F-oYUa_spectrum-overlay`;
$4a75d6c740e7ec84$var$$c77d7b73b2bbd0fb$export$74470528f463af97 = `F-oYUa_spectrum-Underlay ${$4a75d6c740e7ec84$var$$c77d7b73b2bbd0fb$export$39eed38e2296a1d6}`;
$4a75d6c740e7ec84$var$$c77d7b73b2bbd0fb$export$8eb3860104039b44 = `F-oYUa_spectrum-Underlay--transparent`;
$4a75d6c740e7ec84$var$$c77d7b73b2bbd0fb$export$a96755f239de61ee = `F-oYUa_spectrum-overlay--bottom--open`;
$4a75d6c740e7ec84$var$$c77d7b73b2bbd0fb$export$a85c0c6b6cf8598c = `F-oYUa_spectrum-overlay--left--open`;
$4a75d6c740e7ec84$var$$c77d7b73b2bbd0fb$export$85aaa87e65e040bf = `F-oYUa_spectrum-overlay--right--open`;
$4a75d6c740e7ec84$var$$c77d7b73b2bbd0fb$export$b9768db7ffc1bc2 = `F-oYUa_spectrum-overlay--top--open`;
function $4a75d6c740e7ec84$var$$76a452f4e3df11be$export$f360afc887607b02({ isOpen: isOpen, isTransparent: isTransparent, ...otherProps }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($7eprg))).createElement("div", {
        "data-testid": "underlay",
        ...otherProps,
        className: (0, $cYn9G.classNames)(/*@__PURE__*/ $4a75d6c740e7ec84$var$$parcel$interopDefault($4a75d6c740e7ec84$var$$c77d7b73b2bbd0fb$exports), "spectrum-Underlay", {
            "is-open": isOpen,
            "spectrum-Underlay--transparent": isTransparent
        })
    });
}
/**
 * Arrow placement can be done pointing right or down because those paths start at 0, x or y. Because the
 * other two don't, they start at a fractional pixel value, it introduces rounding differences between browsers and
 * between display types (retina with subpixels vs not retina). By flipping them with CSS we can ensure that
 * the path always starts at 0 so that it perfectly overlaps the popover's border.
 * See bottom of file for more explanation.
 */ let $4a75d6c740e7ec84$var$$17b503f7de08fecc$var$arrowPlacement = {
    left: "right",
    right: "right",
    top: "bottom",
    bottom: "bottom"
};
function $4a75d6c740e7ec84$var$$17b503f7de08fecc$var$Popover(props, ref) {
    let { children: children, state: state, ...otherProps } = props;
    let domRef = (0, $cYn9G.useDOMRef)(ref);
    let wrapperRef = (0, $7eprg.useRef)(null);
    return (0, (/*@__PURE__*/$parcel$interopDefault($7eprg))).createElement($4a75d6c740e7ec84$export$c6fdb837b070b4ff, {
        ...otherProps,
        isOpen: state.isOpen,
        nodeRef: wrapperRef
    }, (0, (/*@__PURE__*/$parcel$interopDefault($7eprg))).createElement($4a75d6c740e7ec84$var$$17b503f7de08fecc$var$PopoverWrapper, {
        ref: domRef,
        ...props,
        wrapperRef: wrapperRef
    }, children));
}
const $4a75d6c740e7ec84$var$$17b503f7de08fecc$var$PopoverWrapper = (0, $7eprg.forwardRef)((props, ref)=>{
    let { children: children, isOpen: isOpen, hideArrow: hideArrow, isNonModal: isNonModal, enableBothDismissButtons: enableBothDismissButtons, state: state, wrapperRef: wrapperRef } = props;
    let { styleProps: styleProps } = (0, $cYn9G.useStyleProps)(props);
    let { size: size, borderWidth: borderWidth, arrowRef: arrowRef } = $4a75d6c740e7ec84$var$$17b503f7de08fecc$var$useArrowSize();
    const borderRadius = $4a75d6c740e7ec84$var$$17b503f7de08fecc$var$usePopoverBorderRadius(ref);
    let borderDiagonal = borderWidth * Math.SQRT2;
    let primary = size + borderDiagonal;
    let secondary = primary * 2;
    let { popoverProps: popoverProps, arrowProps: arrowProps, underlayProps: underlayProps, placement: placement } = (0, $20dvM.usePopover)({
        ...props,
        popoverRef: ref,
        maxHeight: null,
        arrowSize: hideArrow ? 0 : secondary,
        arrowBoundaryOffset: borderRadius
    }, state);
    let { focusWithinProps: focusWithinProps } = (0, $aCJeV.useFocusWithin)(props);
    let onPointerDown = ()=>{
        state.close();
    };
    // Attach Transition's nodeRef to outermost wrapper for node.reflow: https://github.com/reactjs/react-transition-group/blob/c89f807067b32eea6f68fd6c622190d88ced82e2/src/Transition.js#L231
    return (0, (/*@__PURE__*/$parcel$interopDefault($7eprg))).createElement("div", {
        ref: wrapperRef
    }, !isNonModal && (0, (/*@__PURE__*/$parcel$interopDefault($7eprg))).createElement($4a75d6c740e7ec84$var$$76a452f4e3df11be$export$f360afc887607b02, {
        isTransparent: true,
        ...(0, $5mLCk.mergeProps)(underlayProps, {
            onPointerDown: onPointerDown
        }),
        isOpen: isOpen
    }), (0, (/*@__PURE__*/$parcel$interopDefault($7eprg))).createElement("div", {
        ...styleProps,
        ...(0, $5mLCk.mergeProps)(popoverProps, focusWithinProps),
        style: {
            ...styleProps.style,
            ...popoverProps.style
        },
        ref: ref,
        className: (0, $cYn9G.classNames)(/*@__PURE__*/ $4a75d6c740e7ec84$var$$parcel$interopDefault($4a75d6c740e7ec84$var$$645594d913f34a2a$exports), "spectrum-Popover", `spectrum-Popover--${placement}`, {
            "spectrum-Popover--withTip": !hideArrow,
            "is-open": isOpen,
            [`is-open--${placement}`]: isOpen
        }, (0, $cYn9G.classNames)(/*@__PURE__*/ $4a75d6c740e7ec84$var$$parcel$interopDefault($4a75d6c740e7ec84$var$$853e19557ad8790f$exports), "spectrum-Popover", "react-spectrum-Popover"), styleProps.className),
        role: "presentation",
        "data-testid": "popover"
    }, (!isNonModal || enableBothDismissButtons) && (0, (/*@__PURE__*/$parcel$interopDefault($7eprg))).createElement((0, $20dvM.DismissButton), {
        onDismiss: state.close
    }), children, hideArrow ? null : (0, (/*@__PURE__*/$parcel$interopDefault($7eprg))).createElement($4a75d6c740e7ec84$var$$17b503f7de08fecc$var$Arrow, {
        arrowProps: arrowProps,
        isLandscape: $4a75d6c740e7ec84$var$$17b503f7de08fecc$var$arrowPlacement[placement] === "bottom",
        arrowRef: arrowRef,
        primary: primary,
        secondary: secondary,
        borderDiagonal: borderDiagonal
    }), (0, (/*@__PURE__*/$parcel$interopDefault($7eprg))).createElement((0, $20dvM.DismissButton), {
        onDismiss: state.close
    })));
});
function $4a75d6c740e7ec84$var$$17b503f7de08fecc$var$usePopoverBorderRadius(popoverRef) {
    let [borderRadius, setBorderRadius] = (0, $7eprg.useState)(0);
    (0, $5mLCk.useLayoutEffect)(()=>{
        if (popoverRef.current) {
            let spectrumBorderRadius = window.getComputedStyle(popoverRef.current).borderRadius;
            if (spectrumBorderRadius !== "") setBorderRadius(parseInt(spectrumBorderRadius, 10));
        }
    }, [
        popoverRef
    ]);
    return borderRadius;
}
function $4a75d6c740e7ec84$var$$17b503f7de08fecc$var$useArrowSize() {
    let [size, setSize] = (0, $7eprg.useState)(20);
    let [borderWidth, setBorderWidth] = (0, $7eprg.useState)(1);
    let arrowRef = (0, $7eprg.useRef)(null);
    (0, $5mLCk.useLayoutEffect)(()=>{
        if (arrowRef.current) {
            let spectrumTipWidth = window.getComputedStyle(arrowRef.current).getPropertyValue("--spectrum-popover-tip-size");
            if (spectrumTipWidth !== "") setSize(parseInt(spectrumTipWidth, 10) / 2);
            let spectrumBorderWidth = window.getComputedStyle(arrowRef.current).getPropertyValue("--spectrum-popover-tip-borderWidth");
            if (spectrumBorderWidth !== "") setBorderWidth(parseInt(spectrumBorderWidth, 10));
        }
    }, []);
    return {
        size: size,
        borderWidth: borderWidth,
        arrowRef: arrowRef
    };
}
function $4a75d6c740e7ec84$var$$17b503f7de08fecc$var$Arrow(props) {
    let { primary: primary, secondary: secondary, isLandscape: isLandscape, arrowProps: arrowProps, borderDiagonal: borderDiagonal, arrowRef: arrowRef } = props;
    let halfBorderDiagonal = borderDiagonal / 2;
    let primaryStart = 0;
    let primaryEnd = primary - halfBorderDiagonal;
    let secondaryStart = halfBorderDiagonal;
    let secondaryMiddle = secondary / 2;
    let secondaryEnd = secondary - halfBorderDiagonal;
    let pathData = isLandscape ? [
        "M",
        secondaryStart,
        primaryStart,
        "L",
        secondaryMiddle,
        primaryEnd,
        "L",
        secondaryEnd,
        primaryStart
    ] : [
        "M",
        primaryStart,
        secondaryStart,
        "L",
        primaryEnd,
        secondaryMiddle,
        "L",
        primaryStart,
        secondaryEnd
    ];
    /* use ceil because the svg needs to always accommodate the path inside it */ return (0, (/*@__PURE__*/$parcel$interopDefault($7eprg))).createElement("svg", {
        xmlns: "http://www.w3.org/svg/2000",
        width: Math.ceil(isLandscape ? secondary : primary),
        height: Math.ceil(isLandscape ? primary : secondary),
        className: (0, $cYn9G.classNames)(/*@__PURE__*/ $4a75d6c740e7ec84$var$$parcel$interopDefault($4a75d6c740e7ec84$var$$645594d913f34a2a$exports), "spectrum-Popover-tip"),
        ref: arrowRef,
        ...arrowProps
    }, (0, (/*@__PURE__*/$parcel$interopDefault($7eprg))).createElement("path", {
        className: (0, $cYn9G.classNames)(/*@__PURE__*/ $4a75d6c740e7ec84$var$$parcel$interopDefault($4a75d6c740e7ec84$var$$645594d913f34a2a$exports), "spectrum-Popover-tip-triangle"),
        d: pathData.join(" ")
    }));
}
let $4a75d6c740e7ec84$export$5b6b19405a83ff9d = (0, $7eprg.forwardRef)($4a75d6c740e7ec84$var$$17b503f7de08fecc$var$Popover);
/**
 * More explanation on popover tips.
 * - I tried changing the calculation of the popover placement in an effort to get it squarely onto the pixel grid.
 * This did not work because the problem was in the svg partial pixel end of the path in the popover right and popover bottom.
 * - I tried creating an extra 'bandaid' path that matched the background color and would overlap the popover border.
 * This didn't work because the border on the svg triangle didn't extend all the way to match nicely with the popover border.
 * - I tried getting the client bounding box and setting the svg to that partial pixel value
 * This didn't work because again the issue was inside the svg
 * - I didn't try drawing the svg backwards
 * This could still be tried
 * - I tried changing the calculation of the popover placement AND the svg height/width so that they were all rounded
 * This seems to have done the trick.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var $4a75d6c740e7ec84$var$$f7ed9f5201273840$exports = {};
$4a75d6c740e7ec84$var$$parcel$export($4a75d6c740e7ec84$var$$f7ed9f5201273840$exports, "focus-ring", ()=>$4a75d6c740e7ec84$var$$f7ed9f5201273840$export$f39a09f249340e2a, (v)=>$4a75d6c740e7ec84$var$$f7ed9f5201273840$export$f39a09f249340e2a = v);
$4a75d6c740e7ec84$var$$parcel$export($4a75d6c740e7ec84$var$$f7ed9f5201273840$exports, "i18nFontFamily", ()=>$4a75d6c740e7ec84$var$$f7ed9f5201273840$export$8c4ee2c50c22c514, (v)=>$4a75d6c740e7ec84$var$$f7ed9f5201273840$export$8c4ee2c50c22c514 = v);
$4a75d6c740e7ec84$var$$parcel$export($4a75d6c740e7ec84$var$$f7ed9f5201273840$exports, "spectrum-overlay--open", ()=>$4a75d6c740e7ec84$var$$f7ed9f5201273840$export$a397eb58038aa381, (v)=>$4a75d6c740e7ec84$var$$f7ed9f5201273840$export$a397eb58038aa381 = v);
$4a75d6c740e7ec84$var$$parcel$export($4a75d6c740e7ec84$var$$f7ed9f5201273840$exports, "is-open", ()=>$4a75d6c740e7ec84$var$$f7ed9f5201273840$export$a9781837241c946d, (v)=>$4a75d6c740e7ec84$var$$f7ed9f5201273840$export$a9781837241c946d = v);
$4a75d6c740e7ec84$var$$parcel$export($4a75d6c740e7ec84$var$$f7ed9f5201273840$exports, "spectrum-FocusRing-ring", ()=>$4a75d6c740e7ec84$var$$f7ed9f5201273840$export$4109102f950813a6, (v)=>$4a75d6c740e7ec84$var$$f7ed9f5201273840$export$4109102f950813a6 = v);
$4a75d6c740e7ec84$var$$parcel$export($4a75d6c740e7ec84$var$$f7ed9f5201273840$exports, "spectrum-FocusRing", ()=>$4a75d6c740e7ec84$var$$f7ed9f5201273840$export$24c7f46a6e3605dd, (v)=>$4a75d6c740e7ec84$var$$f7ed9f5201273840$export$24c7f46a6e3605dd = v);
$4a75d6c740e7ec84$var$$parcel$export($4a75d6c740e7ec84$var$$f7ed9f5201273840$exports, "spectrum-FocusRing--quiet", ()=>$4a75d6c740e7ec84$var$$f7ed9f5201273840$export$2927016961429360, (v)=>$4a75d6c740e7ec84$var$$f7ed9f5201273840$export$2927016961429360 = v);
$4a75d6c740e7ec84$var$$parcel$export($4a75d6c740e7ec84$var$$f7ed9f5201273840$exports, "spectrum-overlay", ()=>$4a75d6c740e7ec84$var$$f7ed9f5201273840$export$39eed38e2296a1d6, (v)=>$4a75d6c740e7ec84$var$$f7ed9f5201273840$export$39eed38e2296a1d6 = v);
$4a75d6c740e7ec84$var$$parcel$export($4a75d6c740e7ec84$var$$f7ed9f5201273840$exports, "spectrum-Modal", ()=>$4a75d6c740e7ec84$var$$f7ed9f5201273840$export$4c0b1e44c3834c85, (v)=>$4a75d6c740e7ec84$var$$f7ed9f5201273840$export$4c0b1e44c3834c85 = v);
$4a75d6c740e7ec84$var$$parcel$export($4a75d6c740e7ec84$var$$f7ed9f5201273840$exports, "spectrum-Modal--fullscreen", ()=>$4a75d6c740e7ec84$var$$f7ed9f5201273840$export$a4423fa77727431a, (v)=>$4a75d6c740e7ec84$var$$f7ed9f5201273840$export$a4423fa77727431a = v);
$4a75d6c740e7ec84$var$$parcel$export($4a75d6c740e7ec84$var$$f7ed9f5201273840$exports, "spectrum-Modal--fullscreenTakeover", ()=>$4a75d6c740e7ec84$var$$f7ed9f5201273840$export$175dd699720b5fb7, (v)=>$4a75d6c740e7ec84$var$$f7ed9f5201273840$export$175dd699720b5fb7 = v);
$4a75d6c740e7ec84$var$$parcel$export($4a75d6c740e7ec84$var$$f7ed9f5201273840$exports, "spectrum-Modal--responsive", ()=>$4a75d6c740e7ec84$var$$f7ed9f5201273840$export$fd1e42aa8ea02a1, (v)=>$4a75d6c740e7ec84$var$$f7ed9f5201273840$export$fd1e42aa8ea02a1 = v);
$4a75d6c740e7ec84$var$$parcel$export($4a75d6c740e7ec84$var$$f7ed9f5201273840$exports, "spectrum-Modal-wrapper", ()=>$4a75d6c740e7ec84$var$$f7ed9f5201273840$export$35bea187ff802494, (v)=>$4a75d6c740e7ec84$var$$f7ed9f5201273840$export$35bea187ff802494 = v);
$4a75d6c740e7ec84$var$$parcel$export($4a75d6c740e7ec84$var$$f7ed9f5201273840$exports, "spectrum-overlay--bottom--open", ()=>$4a75d6c740e7ec84$var$$f7ed9f5201273840$export$a96755f239de61ee, (v)=>$4a75d6c740e7ec84$var$$f7ed9f5201273840$export$a96755f239de61ee = v);
$4a75d6c740e7ec84$var$$parcel$export($4a75d6c740e7ec84$var$$f7ed9f5201273840$exports, "spectrum-overlay--left--open", ()=>$4a75d6c740e7ec84$var$$f7ed9f5201273840$export$a85c0c6b6cf8598c, (v)=>$4a75d6c740e7ec84$var$$f7ed9f5201273840$export$a85c0c6b6cf8598c = v);
$4a75d6c740e7ec84$var$$parcel$export($4a75d6c740e7ec84$var$$f7ed9f5201273840$exports, "spectrum-overlay--right--open", ()=>$4a75d6c740e7ec84$var$$f7ed9f5201273840$export$85aaa87e65e040bf, (v)=>$4a75d6c740e7ec84$var$$f7ed9f5201273840$export$85aaa87e65e040bf = v);
$4a75d6c740e7ec84$var$$parcel$export($4a75d6c740e7ec84$var$$f7ed9f5201273840$exports, "spectrum-overlay--top--open", ()=>$4a75d6c740e7ec84$var$$f7ed9f5201273840$export$b9768db7ffc1bc2, (v)=>$4a75d6c740e7ec84$var$$f7ed9f5201273840$export$b9768db7ffc1bc2 = v);
var $4a75d6c740e7ec84$var$$f7ed9f5201273840$export$f39a09f249340e2a;
var $4a75d6c740e7ec84$var$$f7ed9f5201273840$export$8c4ee2c50c22c514;
var $4a75d6c740e7ec84$var$$f7ed9f5201273840$export$a397eb58038aa381;
var $4a75d6c740e7ec84$var$$f7ed9f5201273840$export$a9781837241c946d;
var $4a75d6c740e7ec84$var$$f7ed9f5201273840$export$4109102f950813a6;
var $4a75d6c740e7ec84$var$$f7ed9f5201273840$export$24c7f46a6e3605dd;
var $4a75d6c740e7ec84$var$$f7ed9f5201273840$export$2927016961429360;
var $4a75d6c740e7ec84$var$$f7ed9f5201273840$export$39eed38e2296a1d6;
var $4a75d6c740e7ec84$var$$f7ed9f5201273840$export$4c0b1e44c3834c85;
var $4a75d6c740e7ec84$var$$f7ed9f5201273840$export$a4423fa77727431a;
var $4a75d6c740e7ec84$var$$f7ed9f5201273840$export$175dd699720b5fb7;
var $4a75d6c740e7ec84$var$$f7ed9f5201273840$export$fd1e42aa8ea02a1;
var $4a75d6c740e7ec84$var$$f7ed9f5201273840$export$35bea187ff802494;
var $4a75d6c740e7ec84$var$$f7ed9f5201273840$export$a96755f239de61ee;
var $4a75d6c740e7ec84$var$$f7ed9f5201273840$export$a85c0c6b6cf8598c;
var $4a75d6c740e7ec84$var$$f7ed9f5201273840$export$85aaa87e65e040bf;
var $4a75d6c740e7ec84$var$$f7ed9f5201273840$export$b9768db7ffc1bc2;
$4a75d6c740e7ec84$var$$f7ed9f5201273840$export$f39a09f249340e2a = `_0YML2q_focus-ring`;
$4a75d6c740e7ec84$var$$f7ed9f5201273840$export$8c4ee2c50c22c514 = `_0YML2q_i18nFontFamily`;
$4a75d6c740e7ec84$var$$f7ed9f5201273840$export$a397eb58038aa381 = `_0YML2q_spectrum-overlay--open`;
$4a75d6c740e7ec84$var$$f7ed9f5201273840$export$a9781837241c946d = `_0YML2q_is-open ${$4a75d6c740e7ec84$var$$f7ed9f5201273840$export$a397eb58038aa381}`;
$4a75d6c740e7ec84$var$$f7ed9f5201273840$export$4109102f950813a6 = `_0YML2q_spectrum-FocusRing-ring`;
$4a75d6c740e7ec84$var$$f7ed9f5201273840$export$24c7f46a6e3605dd = `_0YML2q_spectrum-FocusRing ${$4a75d6c740e7ec84$var$$f7ed9f5201273840$export$4109102f950813a6}`;
$4a75d6c740e7ec84$var$$f7ed9f5201273840$export$2927016961429360 = `_0YML2q_spectrum-FocusRing--quiet`;
$4a75d6c740e7ec84$var$$f7ed9f5201273840$export$39eed38e2296a1d6 = `_0YML2q_spectrum-overlay`;
$4a75d6c740e7ec84$var$$f7ed9f5201273840$export$4c0b1e44c3834c85 = `_0YML2q_spectrum-Modal ${$4a75d6c740e7ec84$var$$f7ed9f5201273840$export$39eed38e2296a1d6}`;
$4a75d6c740e7ec84$var$$f7ed9f5201273840$export$a4423fa77727431a = `_0YML2q_spectrum-Modal--fullscreen`;
$4a75d6c740e7ec84$var$$f7ed9f5201273840$export$175dd699720b5fb7 = `_0YML2q_spectrum-Modal--fullscreenTakeover`;
$4a75d6c740e7ec84$var$$f7ed9f5201273840$export$fd1e42aa8ea02a1 = `_0YML2q_spectrum-Modal--responsive`;
$4a75d6c740e7ec84$var$$f7ed9f5201273840$export$35bea187ff802494 = `_0YML2q_spectrum-Modal-wrapper`;
$4a75d6c740e7ec84$var$$f7ed9f5201273840$export$a96755f239de61ee = `_0YML2q_spectrum-overlay--bottom--open`;
$4a75d6c740e7ec84$var$$f7ed9f5201273840$export$a85c0c6b6cf8598c = `_0YML2q_spectrum-overlay--left--open`;
$4a75d6c740e7ec84$var$$f7ed9f5201273840$export$85aaa87e65e040bf = `_0YML2q_spectrum-overlay--right--open`;
$4a75d6c740e7ec84$var$$f7ed9f5201273840$export$b9768db7ffc1bc2 = `_0YML2q_spectrum-overlay--top--open`;
function $4a75d6c740e7ec84$var$$842084dfa182af65$var$Modal(props, ref) {
    let { children: children, state: state, ...otherProps } = props;
    let domRef = (0, $cYn9G.useDOMRef)(ref);
    let wrapperRef = (0, $7eprg.useRef)(null);
    return (0, (/*@__PURE__*/$parcel$interopDefault($7eprg))).createElement($4a75d6c740e7ec84$export$c6fdb837b070b4ff, {
        ...otherProps,
        isOpen: state.isOpen,
        nodeRef: wrapperRef
    }, (0, (/*@__PURE__*/$parcel$interopDefault($7eprg))).createElement($4a75d6c740e7ec84$var$$842084dfa182af65$var$ModalWrapper, {
        ...props,
        wrapperRef: wrapperRef,
        ref: domRef
    }, children));
}
let $4a75d6c740e7ec84$var$$842084dfa182af65$var$typeMap = {
    fullscreen: "fullscreen",
    fullscreenTakeover: "fullscreenTakeover"
};
let $4a75d6c740e7ec84$var$$842084dfa182af65$var$ModalWrapper = (0, $7eprg.forwardRef)(function(props, ref) {
    let { type: type, children: children, state: state, isOpen: isOpen, wrapperRef: wrapperRef } = props;
    let typeVariant = $4a75d6c740e7ec84$var$$842084dfa182af65$var$typeMap[type];
    let { styleProps: styleProps } = (0, $cYn9G.useStyleProps)(props);
    let { modalProps: modalProps, underlayProps: underlayProps } = (0, $20dvM.useModalOverlay)(props, state, ref);
    let wrapperClassName = (0, $cYn9G.classNames)(/*@__PURE__*/ $4a75d6c740e7ec84$var$$parcel$interopDefault($4a75d6c740e7ec84$var$$f7ed9f5201273840$exports), "spectrum-Modal-wrapper", (0, $cYn9G.classNames)(/*@__PURE__*/ $4a75d6c740e7ec84$var$$parcel$interopDefault($4a75d6c740e7ec84$var$$853e19557ad8790f$exports), "spectrum-Modal-wrapper", "react-spectrum-Modal-wrapper"));
    let modalClassName = (0, $cYn9G.classNames)(/*@__PURE__*/ $4a75d6c740e7ec84$var$$parcel$interopDefault($4a75d6c740e7ec84$var$$f7ed9f5201273840$exports), "spectrum-Modal", {
        "is-open": isOpen
    }, (0, $cYn9G.classNames)(/*@__PURE__*/ $4a75d6c740e7ec84$var$$parcel$interopDefault($4a75d6c740e7ec84$var$$853e19557ad8790f$exports), "spectrum-Modal", "react-spectrum-Modal"), {
        [`spectrum-Modal--${typeVariant}`]: typeVariant
    }, styleProps.className);
    let viewport = (0, $5mLCk.useViewportSize)();
    let style = {
        "--spectrum-visual-viewport-height": viewport.height + "px"
    };
    // Attach Transition's nodeRef to outer most wrapper for node.reflow: https://github.com/reactjs/react-transition-group/blob/c89f807067b32eea6f68fd6c622190d88ced82e2/src/Transition.js#L231
    return (0, (/*@__PURE__*/$parcel$interopDefault($7eprg))).createElement("div", {
        ref: wrapperRef
    }, (0, (/*@__PURE__*/$parcel$interopDefault($7eprg))).createElement($4a75d6c740e7ec84$var$$76a452f4e3df11be$export$f360afc887607b02, {
        ...underlayProps,
        isOpen: isOpen
    }), (0, (/*@__PURE__*/$parcel$interopDefault($7eprg))).createElement("div", {
        className: wrapperClassName,
        style: style
    }, (0, (/*@__PURE__*/$parcel$interopDefault($7eprg))).createElement("div", {
        ...styleProps,
        ...modalProps,
        ref: ref,
        className: modalClassName,
        "data-testid": "modal"
    }, children)));
});
let $4a75d6c740e7ec84$export$2b77a92f1a5ad772 = (0, $7eprg.forwardRef)($4a75d6c740e7ec84$var$$842084dfa182af65$var$Modal);
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var $4a75d6c740e7ec84$var$$930b2f4095bb11d1$exports = {};
$4a75d6c740e7ec84$var$$parcel$export($4a75d6c740e7ec84$var$$930b2f4095bb11d1$exports, "focus-ring", ()=>$4a75d6c740e7ec84$var$$930b2f4095bb11d1$export$f39a09f249340e2a, (v)=>$4a75d6c740e7ec84$var$$930b2f4095bb11d1$export$f39a09f249340e2a = v);
$4a75d6c740e7ec84$var$$parcel$export($4a75d6c740e7ec84$var$$930b2f4095bb11d1$exports, "i18nFontFamily", ()=>$4a75d6c740e7ec84$var$$930b2f4095bb11d1$export$8c4ee2c50c22c514, (v)=>$4a75d6c740e7ec84$var$$930b2f4095bb11d1$export$8c4ee2c50c22c514 = v);
$4a75d6c740e7ec84$var$$parcel$export($4a75d6c740e7ec84$var$$930b2f4095bb11d1$exports, "spectrum-overlay--open", ()=>$4a75d6c740e7ec84$var$$930b2f4095bb11d1$export$a397eb58038aa381, (v)=>$4a75d6c740e7ec84$var$$930b2f4095bb11d1$export$a397eb58038aa381 = v);
$4a75d6c740e7ec84$var$$parcel$export($4a75d6c740e7ec84$var$$930b2f4095bb11d1$exports, "is-open", ()=>$4a75d6c740e7ec84$var$$930b2f4095bb11d1$export$a9781837241c946d, (v)=>$4a75d6c740e7ec84$var$$930b2f4095bb11d1$export$a9781837241c946d = v);
$4a75d6c740e7ec84$var$$parcel$export($4a75d6c740e7ec84$var$$930b2f4095bb11d1$exports, "spectrum-FocusRing-ring", ()=>$4a75d6c740e7ec84$var$$930b2f4095bb11d1$export$4109102f950813a6, (v)=>$4a75d6c740e7ec84$var$$930b2f4095bb11d1$export$4109102f950813a6 = v);
$4a75d6c740e7ec84$var$$parcel$export($4a75d6c740e7ec84$var$$930b2f4095bb11d1$exports, "spectrum-FocusRing", ()=>$4a75d6c740e7ec84$var$$930b2f4095bb11d1$export$24c7f46a6e3605dd, (v)=>$4a75d6c740e7ec84$var$$930b2f4095bb11d1$export$24c7f46a6e3605dd = v);
$4a75d6c740e7ec84$var$$parcel$export($4a75d6c740e7ec84$var$$930b2f4095bb11d1$exports, "spectrum-FocusRing--quiet", ()=>$4a75d6c740e7ec84$var$$930b2f4095bb11d1$export$2927016961429360, (v)=>$4a75d6c740e7ec84$var$$930b2f4095bb11d1$export$2927016961429360 = v);
$4a75d6c740e7ec84$var$$parcel$export($4a75d6c740e7ec84$var$$930b2f4095bb11d1$exports, "spectrum-overlay", ()=>$4a75d6c740e7ec84$var$$930b2f4095bb11d1$export$39eed38e2296a1d6, (v)=>$4a75d6c740e7ec84$var$$930b2f4095bb11d1$export$39eed38e2296a1d6 = v);
$4a75d6c740e7ec84$var$$parcel$export($4a75d6c740e7ec84$var$$930b2f4095bb11d1$exports, "spectrum-Tray", ()=>$4a75d6c740e7ec84$var$$930b2f4095bb11d1$export$ce0704cd084c4f0d, (v)=>$4a75d6c740e7ec84$var$$930b2f4095bb11d1$export$ce0704cd084c4f0d = v);
$4a75d6c740e7ec84$var$$parcel$export($4a75d6c740e7ec84$var$$930b2f4095bb11d1$exports, "spectrum-Tray--fixedHeight", ()=>$4a75d6c740e7ec84$var$$930b2f4095bb11d1$export$79bfb05e59a300b, (v)=>$4a75d6c740e7ec84$var$$930b2f4095bb11d1$export$79bfb05e59a300b = v);
$4a75d6c740e7ec84$var$$parcel$export($4a75d6c740e7ec84$var$$930b2f4095bb11d1$exports, "spectrum-Tray-wrapper", ()=>$4a75d6c740e7ec84$var$$930b2f4095bb11d1$export$641b9b70c23dce66, (v)=>$4a75d6c740e7ec84$var$$930b2f4095bb11d1$export$641b9b70c23dce66 = v);
$4a75d6c740e7ec84$var$$parcel$export($4a75d6c740e7ec84$var$$930b2f4095bb11d1$exports, "spectrum-overlay--bottom--open", ()=>$4a75d6c740e7ec84$var$$930b2f4095bb11d1$export$a96755f239de61ee, (v)=>$4a75d6c740e7ec84$var$$930b2f4095bb11d1$export$a96755f239de61ee = v);
$4a75d6c740e7ec84$var$$parcel$export($4a75d6c740e7ec84$var$$930b2f4095bb11d1$exports, "spectrum-overlay--left--open", ()=>$4a75d6c740e7ec84$var$$930b2f4095bb11d1$export$a85c0c6b6cf8598c, (v)=>$4a75d6c740e7ec84$var$$930b2f4095bb11d1$export$a85c0c6b6cf8598c = v);
$4a75d6c740e7ec84$var$$parcel$export($4a75d6c740e7ec84$var$$930b2f4095bb11d1$exports, "spectrum-overlay--right--open", ()=>$4a75d6c740e7ec84$var$$930b2f4095bb11d1$export$85aaa87e65e040bf, (v)=>$4a75d6c740e7ec84$var$$930b2f4095bb11d1$export$85aaa87e65e040bf = v);
$4a75d6c740e7ec84$var$$parcel$export($4a75d6c740e7ec84$var$$930b2f4095bb11d1$exports, "spectrum-overlay--top--open", ()=>$4a75d6c740e7ec84$var$$930b2f4095bb11d1$export$b9768db7ffc1bc2, (v)=>$4a75d6c740e7ec84$var$$930b2f4095bb11d1$export$b9768db7ffc1bc2 = v);
var $4a75d6c740e7ec84$var$$930b2f4095bb11d1$export$f39a09f249340e2a;
var $4a75d6c740e7ec84$var$$930b2f4095bb11d1$export$8c4ee2c50c22c514;
var $4a75d6c740e7ec84$var$$930b2f4095bb11d1$export$a397eb58038aa381;
var $4a75d6c740e7ec84$var$$930b2f4095bb11d1$export$a9781837241c946d;
var $4a75d6c740e7ec84$var$$930b2f4095bb11d1$export$4109102f950813a6;
var $4a75d6c740e7ec84$var$$930b2f4095bb11d1$export$24c7f46a6e3605dd;
var $4a75d6c740e7ec84$var$$930b2f4095bb11d1$export$2927016961429360;
var $4a75d6c740e7ec84$var$$930b2f4095bb11d1$export$39eed38e2296a1d6;
var $4a75d6c740e7ec84$var$$930b2f4095bb11d1$export$ce0704cd084c4f0d;
var $4a75d6c740e7ec84$var$$930b2f4095bb11d1$export$79bfb05e59a300b;
var $4a75d6c740e7ec84$var$$930b2f4095bb11d1$export$641b9b70c23dce66;
var $4a75d6c740e7ec84$var$$930b2f4095bb11d1$export$a96755f239de61ee;
var $4a75d6c740e7ec84$var$$930b2f4095bb11d1$export$a85c0c6b6cf8598c;
var $4a75d6c740e7ec84$var$$930b2f4095bb11d1$export$85aaa87e65e040bf;
var $4a75d6c740e7ec84$var$$930b2f4095bb11d1$export$b9768db7ffc1bc2;
$4a75d6c740e7ec84$var$$930b2f4095bb11d1$export$f39a09f249340e2a = `UuxJvG_focus-ring`;
$4a75d6c740e7ec84$var$$930b2f4095bb11d1$export$8c4ee2c50c22c514 = `UuxJvG_i18nFontFamily`;
$4a75d6c740e7ec84$var$$930b2f4095bb11d1$export$a397eb58038aa381 = `UuxJvG_spectrum-overlay--open`;
$4a75d6c740e7ec84$var$$930b2f4095bb11d1$export$a9781837241c946d = `UuxJvG_is-open ${$4a75d6c740e7ec84$var$$930b2f4095bb11d1$export$a397eb58038aa381}`;
$4a75d6c740e7ec84$var$$930b2f4095bb11d1$export$4109102f950813a6 = `UuxJvG_spectrum-FocusRing-ring`;
$4a75d6c740e7ec84$var$$930b2f4095bb11d1$export$24c7f46a6e3605dd = `UuxJvG_spectrum-FocusRing ${$4a75d6c740e7ec84$var$$930b2f4095bb11d1$export$4109102f950813a6}`;
$4a75d6c740e7ec84$var$$930b2f4095bb11d1$export$2927016961429360 = `UuxJvG_spectrum-FocusRing--quiet`;
$4a75d6c740e7ec84$var$$930b2f4095bb11d1$export$39eed38e2296a1d6 = `UuxJvG_spectrum-overlay`;
$4a75d6c740e7ec84$var$$930b2f4095bb11d1$export$ce0704cd084c4f0d = `UuxJvG_spectrum-Tray ${$4a75d6c740e7ec84$var$$930b2f4095bb11d1$export$39eed38e2296a1d6}`;
$4a75d6c740e7ec84$var$$930b2f4095bb11d1$export$79bfb05e59a300b = `UuxJvG_spectrum-Tray--fixedHeight`;
$4a75d6c740e7ec84$var$$930b2f4095bb11d1$export$641b9b70c23dce66 = `UuxJvG_spectrum-Tray-wrapper`;
$4a75d6c740e7ec84$var$$930b2f4095bb11d1$export$a96755f239de61ee = `UuxJvG_spectrum-overlay--bottom--open`;
$4a75d6c740e7ec84$var$$930b2f4095bb11d1$export$a85c0c6b6cf8598c = `UuxJvG_spectrum-overlay--left--open`;
$4a75d6c740e7ec84$var$$930b2f4095bb11d1$export$85aaa87e65e040bf = `UuxJvG_spectrum-overlay--right--open`;
$4a75d6c740e7ec84$var$$930b2f4095bb11d1$export$b9768db7ffc1bc2 = `UuxJvG_spectrum-overlay--top--open`;
function $4a75d6c740e7ec84$var$$1afc87f3d16a5a1c$var$Tray(props, ref) {
    let { children: children, state: state, ...otherProps } = props;
    let domRef = (0, $cYn9G.useDOMRef)(ref);
    let wrapperRef = (0, $7eprg.useRef)(null);
    return (0, (/*@__PURE__*/$parcel$interopDefault($7eprg))).createElement($4a75d6c740e7ec84$export$c6fdb837b070b4ff, {
        ...otherProps,
        isOpen: state.isOpen,
        nodeRef: wrapperRef
    }, (0, (/*@__PURE__*/$parcel$interopDefault($7eprg))).createElement($4a75d6c740e7ec84$var$$1afc87f3d16a5a1c$var$TrayWrapper, {
        ...props,
        wrapperRef: wrapperRef,
        ref: domRef
    }, children));
}
let $4a75d6c740e7ec84$var$$1afc87f3d16a5a1c$var$TrayWrapper = (0, $7eprg.forwardRef)(function(props, ref) {
    let { children: children, isOpen: isOpen, isFixedHeight: isFixedHeight, state: state, wrapperRef: wrapperRef } = props;
    let { styleProps: styleProps } = (0, $cYn9G.useStyleProps)(props);
    let { modalProps: modalProps, underlayProps: underlayProps } = (0, $20dvM.useModalOverlay)({
        ...props,
        isDismissable: true
    }, state, ref);
    // We need to measure the window's height in JS rather than using percentages in CSS
    // so that contents (e.g. menu) can inherit the max-height properly. Using percentages
    // does not work properly because there is nothing to base the percentage on.
    // We cannot use vh units because mobile browsers adjust the window height dynamically
    // when the address bar/bottom toolbars show and hide on scroll and vh units are fixed.
    // Also, the visual viewport is smaller than the layout viewport when the virtual keyboard
    // is up, so use the VisualViewport API to ensure the tray is displayed above the keyboard.
    let viewport = (0, $5mLCk.useViewportSize)();
    let wrapperStyle = {
        "--spectrum-visual-viewport-height": viewport.height + "px"
    };
    let wrapperClassName = (0, $cYn9G.classNames)(/*@__PURE__*/ $4a75d6c740e7ec84$var$$parcel$interopDefault($4a75d6c740e7ec84$var$$930b2f4095bb11d1$exports), "spectrum-Tray-wrapper");
    let className = (0, $cYn9G.classNames)(/*@__PURE__*/ $4a75d6c740e7ec84$var$$parcel$interopDefault($4a75d6c740e7ec84$var$$930b2f4095bb11d1$exports), "spectrum-Tray", {
        "is-open": isOpen,
        "spectrum-Tray--fixedHeight": isFixedHeight
    }, (0, $cYn9G.classNames)(/*@__PURE__*/ $4a75d6c740e7ec84$var$$parcel$interopDefault($4a75d6c740e7ec84$var$$853e19557ad8790f$exports), "spectrum-Tray", "react-spectrum-Tray"), styleProps.className);
    // Attach Transition's nodeRef to outer most wrapper for node.reflow: https://github.com/reactjs/react-transition-group/blob/c89f807067b32eea6f68fd6c622190d88ced82e2/src/Transition.js#L231
    return (0, (/*@__PURE__*/$parcel$interopDefault($7eprg))).createElement("div", {
        ref: wrapperRef
    }, (0, (/*@__PURE__*/$parcel$interopDefault($7eprg))).createElement($4a75d6c740e7ec84$var$$76a452f4e3df11be$export$f360afc887607b02, {
        ...underlayProps,
        isOpen: isOpen
    }), (0, (/*@__PURE__*/$parcel$interopDefault($7eprg))).createElement("div", {
        className: wrapperClassName,
        style: wrapperStyle
    }, (0, (/*@__PURE__*/$parcel$interopDefault($7eprg))).createElement("div", {
        ...styleProps,
        ...modalProps,
        className: className,
        ref: ref,
        "data-testid": "tray"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($7eprg))).createElement((0, $20dvM.DismissButton), {
        onDismiss: state.close
    }), children, (0, (/*@__PURE__*/$parcel$interopDefault($7eprg))).createElement((0, $20dvM.DismissButton), {
        onDismiss: state.close
    }))));
});
let $4a75d6c740e7ec84$export$4589ed81930b555c = (0, $7eprg.forwardRef)($4a75d6c740e7ec84$var$$1afc87f3d16a5a1c$var$Tray);

});
parcelRegister("aQDJL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7e5d95b07bf40f3d$export$2e2bcd8739ae039; });

var $7uTSd = parcelRequire("7uTSd");

var $ybTpo = parcelRequire("ybTpo");


var $7eprg = parcelRequire("7eprg");

var $5hg2n = parcelRequire("5hg2n");

var $fGZrG = parcelRequire("fGZrG");


var $hiS7v = parcelRequire("hiS7v");

var $8GmTN = parcelRequire("8GmTN");
var $7e5d95b07bf40f3d$export$bb38bb9a1161268 = "unmounted";
var $7e5d95b07bf40f3d$export$84cbff306f539230 = "exited";
var $7e5d95b07bf40f3d$export$df38205c966be359 = "entering";
var $7e5d95b07bf40f3d$export$78e9e6e3e014d60a = "entered";
var $7e5d95b07bf40f3d$export$4aacc83d4d59139f = "exiting";
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $7e5d95b07bf40f3d$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $ybTpo.default)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $7e5d95b07bf40f3d$export$84cbff306f539230;
                _this.appearStatus = $7e5d95b07bf40f3d$export$df38205c966be359;
            } else initialStatus = $7e5d95b07bf40f3d$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $7e5d95b07bf40f3d$export$bb38bb9a1161268;
        else initialStatus = $7e5d95b07bf40f3d$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $7e5d95b07bf40f3d$export$bb38bb9a1161268) return {
            status: $7e5d95b07bf40f3d$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $7e5d95b07bf40f3d$export$df38205c966be359 && status !== $7e5d95b07bf40f3d$export$78e9e6e3e014d60a) nextStatus = $7e5d95b07bf40f3d$export$df38205c966be359;
            } else if (status === $7e5d95b07bf40f3d$export$df38205c966be359 || status === $7e5d95b07bf40f3d$export$78e9e6e3e014d60a) nextStatus = $7e5d95b07bf40f3d$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== "number") {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $7e5d95b07bf40f3d$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($5hg2n))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $8GmTN.forceReflow)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $7e5d95b07bf40f3d$export$84cbff306f539230) this.setState({
            status: $7e5d95b07bf40f3d$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($5hg2n))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $fGZrG.default).disabled) {
            this.safeSetState({
                status: $7e5d95b07bf40f3d$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $7e5d95b07bf40f3d$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $7e5d95b07bf40f3d$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($5hg2n))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $fGZrG.default).disabled) {
            this.safeSetState({
                status: $7e5d95b07bf40f3d$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $7e5d95b07bf40f3d$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $7e5d95b07bf40f3d$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($5hg2n))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $7e5d95b07bf40f3d$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $7uTSd.default)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($7eprg))).createElement((0, $hiS7v.default).Provider, {
            value: null
        }, typeof children === "function" ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($7eprg))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($7eprg))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($7eprg))).Component);
$7e5d95b07bf40f3d$var$Transition.contextType = (0, $hiS7v.default);
$7e5d95b07bf40f3d$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $7e5d95b07bf40f3d$var$noop() {}
$7e5d95b07bf40f3d$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $7e5d95b07bf40f3d$var$noop,
    onEntering: $7e5d95b07bf40f3d$var$noop,
    onEntered: $7e5d95b07bf40f3d$var$noop,
    onExit: $7e5d95b07bf40f3d$var$noop,
    onExiting: $7e5d95b07bf40f3d$var$noop,
    onExited: $7e5d95b07bf40f3d$var$noop
};
$7e5d95b07bf40f3d$var$Transition.UNMOUNTED = $7e5d95b07bf40f3d$export$bb38bb9a1161268;
$7e5d95b07bf40f3d$var$Transition.EXITED = $7e5d95b07bf40f3d$export$84cbff306f539230;
$7e5d95b07bf40f3d$var$Transition.ENTERING = $7e5d95b07bf40f3d$export$df38205c966be359;
$7e5d95b07bf40f3d$var$Transition.ENTERED = $7e5d95b07bf40f3d$export$78e9e6e3e014d60a;
$7e5d95b07bf40f3d$var$Transition.EXITING = $7e5d95b07bf40f3d$export$4aacc83d4d59139f;
var $7e5d95b07bf40f3d$export$2e2bcd8739ae039 = $7e5d95b07bf40f3d$var$Transition;

});
parcelRegister("7uTSd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5756ad07a79ad55a$export$2e2bcd8739ae039; });
function $5756ad07a79ad55a$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

});

parcelRegister("ybTpo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $066c66bb13e1fe61$export$2e2bcd8739ae039; });

var $i09if = parcelRequire("i09if");
function $066c66bb13e1fe61$export$2e2bcd8739ae039(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    (0, $i09if.default)(subClass, superClass);
}

});
parcelRegister("i09if", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d1af6f8675849ec6$export$2e2bcd8739ae039; });
function $d1af6f8675849ec6$export$2e2bcd8739ae039(o, p) {
    $d1af6f8675849ec6$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $d1af6f8675849ec6$export$2e2bcd8739ae039(o, p);
}

});


parcelRegister("fGZrG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b6ca710c798fc493$export$2e2bcd8739ae039; });
var $b6ca710c798fc493$export$2e2bcd8739ae039 = {
    disabled: false
};

});

parcelRegister("hiS7v", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c98e193cc7fcd9fb$export$2e2bcd8739ae039; });

var $7eprg = parcelRequire("7eprg");
var $c98e193cc7fcd9fb$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($7eprg))).createContext(null);

});

parcelRegister("8GmTN", function(module, exports) {

$parcel$export(module.exports, "forceReflow", function () { return $6524023da1daa0a9$export$7d26bbb1236dafd6; });
var $6524023da1daa0a9$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};

});



parcelRegister("1yMrW", function(module, exports) {

$parcel$export(module.exports, "useOverlayTriggerState", function () { return $122e8c89b8e7fca0$export$61c6a8c84e605fb6; });

var $7eprg = parcelRequire("7eprg");

var $3cfCM = parcelRequire("3cfCM");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $122e8c89b8e7fca0$export$61c6a8c84e605fb6(props) {
    let [isOpen, setOpen] = (0, $3cfCM.useControlledState)(props.isOpen, props.defaultOpen || false, props.onOpenChange);
    const open = (0, $7eprg.useCallback)(()=>{
        setOpen(true);
    }, [
        setOpen
    ]);
    const close = (0, $7eprg.useCallback)(()=>{
        setOpen(false);
    }, [
        setOpen
    ]);
    const toggle = (0, $7eprg.useCallback)(()=>{
        setOpen(!isOpen);
    }, [
        setOpen,
        isOpen
    ]);
    return {
        isOpen: isOpen,
        setOpen: setOpen,
        open: open,
        close: close,
        toggle: toggle
    };
}

});


//# sourceMappingURL=TuxContainer.35b332d6.js.map
